export function ensureStringArray(val: unknown): string[] {
  if (val === null || typeof val === 'undefined') {
    return [];
  } else if (typeof val === 'string') {
    return [val];
  } else if (Array.isArray(val)) {
    return val.filter(d => (typeof d === 'string' ? d.trim() : false));
  } else {
    throw new Error(`Expecting string or string array, got ${val}`);
  }
}

export function flatBem(block: string) {
  return function(_elements?: string | string[], _modifiers?: string | string[]): string {
    if (typeof _elements === 'undefined') return block;
    const elementsArray = ensureStringArray(_elements);
    if (elementsArray.length === 0) throw new Error();
    // const mainElement = elementsArray[elementsArray.length - 1];
    const resClasses: string[] = [];
    for (const element of elementsArray) {
      resClasses.push(`${block}__${element}`);
      for (const modifier of ensureStringArray(_modifiers)) {
        resClasses.push(`${block}__${element}_${modifier}`);
      }
    }
    return resClasses.join(' ');
  };
}
